module.exports = __webpack_public_path__ + "firebase-messaging-sw.js";